import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { IssueChip } from '~/components/IssueChip/IssueChip';

export type IssueChipCellValue = Union.Nullable<number>;

interface IssueChipCellProps<R extends GridValidRowModel = any> {
  value: IssueChipCellValue;
  row: R;
}

export const IssueChipCell = <R extends GridValidRowModel = any>({ value }: IssueChipCellProps<R>) => {
  return value ? (
    <div>
      <IssueChip count={value} />
    </div>
  ) : null;
};
